import React from 'react';
import { Card, Typography, Timeline, Tag } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const { Title, Text } = Typography;

interface ConfigHistoryItem {
  id: string;
  configSystemId: string;
  key: string;
  valueType: string;
  previousValue: string;
  newValue: string;
  action: string;
  createdAt: string;
  createdBy: string;
}

interface ConfigHistoryProps {
  history?: ConfigHistoryItem[];
}

const ConfigHistory: React.FC<ConfigHistoryProps> = ({ history }) => {
  const parseRankingConfig = (value: string) => {
    try {
      const config = JSON.parse(value);
      return config.map((item: any) => ({
        rank: item.rank,
        values: item.values,
      }));
    } catch {
      return [];
    }
  };

  const formatRankingConfig = (config: any[]) => {
    return config
      .map((item) => {
        const [min, max] = item.values;
        return `${item.rank}: ${min}${max ? ` - ${max}` : '+'}`;
      })
      .join(', ');
  };

  return (
    <Card
      title={
        <Title level={3} className='!mb-0'>
          Configuration History
        </Title>
      }
      className='shadow-lg h-full'
      bodyStyle={{ height: 'calc(100vh - 200px)', overflow: 'hidden' }}
    >
      <div className='h-full overflow-y-auto pr-2 pt-2'>
        <Timeline
          items={history?.map((item) => ({
            color: item.action === 'UPDATE' ? 'blue' : 'green',
            children: (
              <div className='mb-4'>
                <div className='flex items-center gap-2 mb-2'>
                  <Tag color={item.action === 'UPDATE' ? 'blue' : 'green'}>{item.action}</Tag>
                  <Text type='secondary'>{dayjs(item.createdAt).format('DD/MM/YYYY HH:mm')}</Text>
                  {item.createdBy && (
                    <div className='flex items-center gap-1 text-gray-500'>
                      <UserOutlined />
                      <Text type='secondary'>{item.createdBy}</Text>
                    </div>
                  )}
                </div>
                <div className='space-y-2'>
                  <div>
                    <Text strong>Previous Value:</Text>
                    <div className='mt-1 text-gray-600'>
                      {formatRankingConfig(parseRankingConfig(item.previousValue))}
                    </div>
                  </div>
                  <div>
                    <Text strong>New Value:</Text>
                    <div className='mt-1 text-gray-600'>
                      {formatRankingConfig(parseRankingConfig(item.newValue))}
                    </div>
                  </div>
                </div>
              </div>
            ),
          }))}
        />
      </div>
    </Card>
  );
};

export default ConfigHistory;
